module.exports = __webpack_public_path__ + "static/img/10.6fc7683.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/10.png
// module id = +G+X
// module chunks = 0